// Generated by CoffeeScript 2.7.0
var AttachmentField, WebAdmin__AssignmentConcern;

import AttachmentLayer from 'trunks/vue/admin/compositions/attachment_layer.js';

AttachmentField = class AttachmentField {
  constructor(element, overlay) {
    this.element = element;
    this.overlay = overlay;
    this.element = DomMaster.wrap(this.element);
    this.overlay = DomMaster.wrap(this.overlay);
    this.attachments = this.element.findAll('.attachment-item');
    this._addDoms();
    this._enterSelectModeBtn = this.element.find('.enter-select-mode-btn');
    this._selectModeActions = this.element.find('.select-mode-actions');
    this.bindEvents();
  }

  bindEvents() {
    // click attachment-item
    this.element.node.proxy('click', '.attachment-item', (event) => {
      var attachment_item, is_all_selected;
      attachment_item = DomMaster.wrap(event._target);
      // not in selecting mode
      if (!this.element.containsClass('selecting')) {
        return;
      }
      // select or unselect attachment
      attachment_item.toggleClass('selected');
      // all-selected
      is_all_selected = _.every(this.attachments, function(item) {
        return item.containsClass('selected');
      });
      if (is_all_selected) {
        return this._AddAllSelectedStyle();
      } else {
        // if field is all-selected then call func else do nothing
        if (this.element.containsClass('all-selected')) {
          return this._AddNotAllSelectedStyle();
        }
      }
    });
    // click select-all btn
    this.element.node.proxy('click', '.toggle-select-all-btn', (event) => {
      if (this.element.containsClass('all-selected')) { // all-selected
        return this._cancelSelectAll();
      } else {
        return this._selectAll();
      }
    });
    // click exit mode btn
    return this.element.node.proxy('click', '.exit-select-mode-btn', () => {
      _.each(this.overlay._attachmentsDownloadCollection, function(attachment_field) {
        return attachment_field.exitSelectMode();
      });
      return this.overlay.find('.flow-footer .batch-download-btn').remove();
    });
  }

  enterSelectMode() {
    this.element.addClass('selecting');
    this._enterSelectModeBtn.hide();
    return this._selectModeActions.show();
  }

  exitSelectMode() {
    this.element.removeClass('selecting');
    this._cancelSelectAll();
    this._enterSelectModeBtn.show();
    return this._selectModeActions.hide();
  }

  _selectAll() {
    // select all attachments
    _.each(this.attachments, function(attachment) {
      return attachment.addClass('selected');
    });
    return this._AddAllSelectedStyle();
  }

  // add field that all attachments are selected style
  _AddAllSelectedStyle() {
    this.element.addClass('all-selected');
    return this.element.find('.toggle-select-all-btn').replaceWith(`<div class="btn text-btn btn-primary toggle-select-all-btn">
  <i class="slp-check"></i>
  <span>全选</span>
</div>`);
  }

  _cancelSelectAll() {
    // cancel select all attachments
    _.each(this.attachments, function(attachment) {
      return attachment.removeClass('selected');
    });
    return this._AddNotAllSelectedStyle();
  }

  // add field that attachments are not all-selected style
  _AddNotAllSelectedStyle() {
    this.element.removeClass('all-selected');
    return this.element.find('.toggle-select-all-btn').replaceWith(`<div class="btn text-btn btn-default toggle-select-all-btn">全选</div>`);
  }

  _addDoms() {
    // add attachment-item select icon
    return _.each(this.attachments, function(item) {
      return item.prepend(`<div class="selected-icon">
  <i class="slp-check-circle-o"></i>
</div>
<div class="unselect-icon">
  <i class="slp-check-circle-o"></i>
</div>`);
    });
  }

};

export default WebAdmin__AssignmentConcern = {
  displayAttachment: function(target) {
    var attachment_index;
    attachment_index = _.indexOf(_.pluck(this.attachments, 'id'), parseInt(target.data('attachment-id')));
    if (this._attachment_layer) {
      this._attachment_layer.updateAttachments(this.attachments);
      this._attachment_layer.updateCurrentIndex(attachment_index);
      return this._attachment_layer.open();
    } else {
      return this._attachment_layer = new AttachmentLayer({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('layer_container'),
        data: {
          attachments: this.attachments,
          currentIndex: attachment_index
        }
      });
    }
  },
  _initPreviewSignature: function() {
    return _.each(DomMaster.findAll('.esignature'), function(el) {
      var esignature_url;
      esignature_url = el.find('img').node.src;
      el.replaceWith(`<div class="esignature esignature-popover popover bottom h-center popover-large">
  <div class="trigger">
    <img src="${esignature_url}" alt='esignature'>
  </div>
  <div class="content">
    <div class="caret"></div>
    <img src="${esignature_url}" alt='esignature' width="100%">
  </div>
</div>`);
      return new Skylark.Elements.Popover(el.node);
    });
  },
  // batch download
  _bindBatchDownloadEvents: function(journey_id) {
    if (this.overlay_el._isBindBatchDownloadEvents) {
      return;
    }
    this.overlay_el._isBindBatchDownloadEvents = true;
    // add necessary dom
    _.each(this.overlay_el.findAll('.file-field-list-item'), function(field) {
      if (field.containsClass('null-attachments')) {
        return;
      }
      // add file-field title right-action buttons
      return field.find('.right-actions').html(`<div class="btn text-btn btn-default enter-select-mode-btn ml-6 zero-flex-shirnk">下载</div>
<div class="select-mode-actions force-no-wrap" hidden='true'>
  <div class="btn text-btn btn-default exit-select-mode-btn mr-4 ml-6">取消下载</div>
  <div class="btn text-btn btn-default toggle-select-all-btn">全选</div>
</div>`);
    });
    // enter select mode
    this.overlay_el.node.proxy('click', '.enter-select-mode-btn', (event) => {
      var field_el;
      if (this.overlay_el._attachmentsDownloadCollection) {
        // all file-field turn-to selecting mode
        _.each(this.overlay_el._attachmentsDownloadCollection, function(attachment_field) {
          return attachment_field.enterSelectMode();
        });
      } else {
        this.overlay_el._attachmentsDownloadCollection = _.compact(_.map(this.overlay_el.findAll('.file-field-list-item'), (field_el) => {
          if (field_el.containsClass('null-attachments')) {
            return;
          }
          (field_el.node.__attField__ = new AttachmentField(field_el, this.overlay_el)).enterSelectMode();
          return field_el.node.__attField__;
        }));
      }
      field_el = DomMaster.wrap(event._target).closest('.file-field-list-item');
      field_el.node.__attField__._selectAll();
      // add batch-download btn in footer
      return this.overlay_el.find('.flow-footer .right').prepend(`<div class="btn text-btn btn-default ml-4 batch-download-btn">
  <i class="slp-download-o"></i>
  <span>下载</span>
</div>`);
    });
    return this.overlay_el.node.proxy('click', '.flow-footer .batch-download-btn', (event) => {
      this._download_btn = DomMaster.wrap(event._target);
      if (this._download_btn.containsClass('disabled')) {
        return;
      }
      this._download_btn.addClass('disabled');
      this._download_btn.find('span').html('下载中');
      return this.__batchDownloadAttachments(journey_id);
    });
  },
  __batchDownloadAttachments: function(journey_id) {
    var attachment_ids, download_collection_path;
    attachment_ids = _.map(this.overlay_el.findAll('.attachments>.selected'), function(attachment_item) {
      return parseInt(attachment_item.data('attachment-id'));
    });
    download_collection_path = `yet_another_workflow/journeys/${journey_id}/attachments/download_collection`;
    return Skylark.Libs.Ajax.post(Skylark.Helpers.UrlHelper.namespaceUrlFor(download_collection_path), {
      contentType: 'application/json; charset=utf-8',
      responseType: 'script',
      data: {
        ids: attachment_ids
      },
      success: () => {
        // all file-field exit selecting mode
        _.each(this.overlay_el._attachmentsDownloadCollection, function(attachment_field) {
          return attachment_field.exitSelectMode();
        });
        // remove batch-download btn
        return this.overlay_el.find('.flow-footer .batch-download-btn').remove();
      }
    });
  }
};
